module.exports = __webpack_public_path__ + "static/ravnica-street-trio-e278dfa255e17b7cefa11b04cb0a4e1e.jpg";